import React, { CSSProperties, FC } from "react";

interface ImageProps {
  src: string;
  style?: CSSProperties;
  className?: string;
  alt?: string;
}


const Image:React.FC<ImageProps> = ({alt,className,src}) => {
  return (
  <img alt={alt} className={className} src={src} ></img>
  )
}

export default Image

